<script lang="ts">
  import { Input } from 'sveltestrap';
  import type { Vehicle } from '../Model/Vehicle';
  import { vehiclesService } from '../services';

  export let id: string;

  let plate: string = "Sin vehiculo adherido";
  let vehicle: Vehicle;

  $: getName(id);

  async function getName(id: string) {
    if(!id) return;
    
    try {
      vehicle = await vehiclesService.findOne(id);
      plate = vehicle.plate;
    } catch { }    
  }
</script>

<Input type="text" value={plate} readonly />